// src/lib/planLimits.js — FASE 4 · tradução dos erros de limite do plano (mig 18).
// O trigger check_limite_obras_plano() levanta 'LIMITE_OBRAS: …'. Aqui viram
// mensagem amigável com dica de upgrade (tela Planos · Sistema → Planos).

/** Se o erro é de limite/carência do plano, devolve a mensagem amigável; senão null. */
export function planLimitMsg(error) {
  const m = String(error?.message || error || '');
  let i = m.indexOf('LIMITE_OBRAS:');
  if (i !== -1) return '🔒 ' + m.slice(i + 'LIMITE_OBRAS:'.length).trim() + ' Veja os planos em Sistema → Planos.';
  i = m.indexOf('REATIVACAO_CARENCIA:');
  if (i !== -1) return '⏳ ' + m.slice(i + 'REATIVACAO_CARENCIA:'.length).trim();
  i = m.indexOf('LIMITE_FUNCIONARIOS:');
  if (i !== -1) return '🔒 ' + m.slice(i + 'LIMITE_FUNCIONARIOS:'.length).trim() + ' Veja os planos em Sistema → Planos.';
  return null;
}
